// extracted by mini-css-extract-plugin
module.exports = {"toPriceSelect":"price_toPriceSelect__CFsXg","errorBox":"price_errorBox__nLE4V"};